import { GraphQLClient } from 'graphql-request'
import { getInstance } from '@/auth'

export default {
  async request(query, variables = {}, options = {}) {
    const { draft, arrayStrategy = 'diff' } = options
    let instance = getInstance()
    let token

    try {
      token = await instance.getTokenSilently()
    } catch (err) {}

    const headers = {
      'accept-language': sessionStorage.getItem('lang'),
      'array-strategy': arrayStrategy,
    }

    if (token) headers['authorization'] = `Bearer ${token}`
    if (draft) headers['kvass-draft'] = draft

    return new GraphQLClient(process.env.VUE_APP_API + '/graphql', {
      headers,
    }).request(query, variables)
  },
}
